import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Dialog, DialogContentType, DialogFooterType } from '@dotcom/crown-ui';
import { FormFieldAddress } from '../../global-types/addresses';
import { useFormFieldGenerator } from '../../hooks/use-form-field-generator';
import { getCurrentRegion } from '../../regional-config/get-regional-config';
import { FormFieldsGenerator } from '../form-fields-generator/form-fields-generator';
import styles from './edit-address-dialog.module.scss';
import { EditAddressDialogProps } from './edit-address-types';
import { editAddressFormFieldList } from './utils/edit-address-form-field-list';

export const EditAddressDialog = ({
  title,
  accentIcon,
  formHandlers,
  isEditAddressVisible,
  onCloseEditAddress,
  actionButton,
}: EditAddressDialogProps): React.ReactElement => {
  const region = getCurrentRegion();

  const { generatedFormFields } = useFormFieldGenerator(
    formHandlers as unknown as UseFormReturn<FormFieldAddress>,
    'edit-address',
    editAddressFormFieldList,
  );

  const typedAccentIcon = accentIcon as any;
  const { setValue } = formHandlers;

  return (
    <Dialog
      id={'domid-edit-address-dialog'}
      title={title}
      locale={region}
      accentIcon={typedAccentIcon}
      hasGrayBackground={true}
      type={DialogContentType.FeatureModal}
      footerType={DialogFooterType.SingleButton}
      isOpen={isEditAddressVisible}
      onClose={onCloseEditAddress}
      closeButtonId={`edit-address-dialog-close-button`}
      dialogClassName={`${styles['edit-address-dialog-wrapper']} ${styles['edit-address-dialog']} `}
      actionButton={actionButton}
      testId={'edit-address-dialog'}
    >
      <FormFieldsGenerator
        selectedFormFields={generatedFormFields}
        register={formHandlers.register}
        setValue={setValue}
      />
    </Dialog>
  );
};
